export default __webpack_public_path__ + "static/media/future.e0ea4b7d.jpg";